import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/modules/healthcare/medical-staff";

export const Route = createFileRoute(
  "/admin/_modules/_healthcare/medical-staff"
)({
  component: Page,
});
